enum AllowanceType {
  Monthly,
  Annual,
}

export default AllowanceType
